// Left here for migrating people to shared-assets
// To be removed when hound shows it no longer referenced
angular.module('kareo.ui.configuration', []);
